import { useEffect } from "react";

const DEFAULTS = {
  title: "Nesta | Affordable, High Quality Furniture for Modern Living",
  description:
    "Nesta — affordable, high quality furniture for modern living. Shop minimalist sofas, chairs, beds, dining and outdoor furniture with free UK delivery.",
};

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, description, image } = {}) {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }
    return () => {
      document.title = DEFAULTS.title;
      setMeta("name", "description", DEFAULTS.description);
    };
  }, [title, description, image]);
}
